class DataSmartController {
    constructor() {

    }
    goApplication(){
        window.open('/application')
    }
}

export default DataSmartController;



// WEBPACK FOOTER //
// ./src/app/components/face/data-smart/data-smart.controller.js